// import { Navigate } from "react-router-dom";
// import { getUserDetailsInLocalStorage } from "./UserDetails";

// const ScopeProtectedRoute = ({ children, scopes }) => {
//   const user = getUserDetailsInLocalStorage();
//   const role = user.role;
  
//   if(role == "admin") {
//     return children;
//   }

//   if(!scopes) {
//     return children;
//   }

//   const userScopes = new String(user.scope).split(",");

//   // check scopes
//   const hasAccess = scopes?.some((scope)=>userScopes?.includes(scope));

//   if(hasAccess) {
//     return children;
//   }

//   return <Navigate to="/no-access" replace />;
// };

// export default ScopeProtectedRoute;


import { Navigate } from "react-router-dom";
import { getUserDetailsInLocalStorage } from "./UserDetails";

const ScopeProtectedRoute = ({ children, scopes }) => {
  const user = getUserDetailsInLocalStorage();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const { role, scope } = user;
  
  if (role === "admin") {
    return children;
  }

  if (!scopes) {
    return children;
  }

  // FIX: Handle null/undefined scope
  const userScopes = scope ? String(scope).split(",") : [];
  
  const hasAccess = scopes?.some((requiredScope) => 
    userScopes?.includes(requiredScope)
  );

  if (hasAccess) {
    return children;
  }

  return <Navigate to="/no-access" replace />;
};

export default ScopeProtectedRoute;